<template lang="pug">
section.widget
  .widget-header
    h2.widget-title
      //- span.title-icon &#x2726;
      span.display-title What's New This Month
    button.events-pill 3 NEW EVENTS &rsaquo;

  .carousel-viewport
    .carousel-track(
      ref="track"
      @mouseenter="pauseMarquee"
      @mouseleave="resumeMarquee"
    )
      .card(v-for="(item, index) in displayList" :key="index")
        .card-thumb
          img(
            :src="item.img"
            :alt="item.alt"
            loading="lazy"
            @click="openPage(item.link)"
          )

        .card-body
          .card-timer
            svg(width="13" height="13" fill="#fbbf24" viewBox="0 0 20 20")
              path(
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clip-rule="evenodd"
              )
            span.timer-label {{ formatEndDate(item.end, item.option) }}
</template>

<script>
export default {
  name: 'WhatsNewMarquee',

  data() {
    return {
      months: [
        'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
        'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
      ],

      gap: 16,
      speed: 18,
      resizeTimer: null,
      styleEl: null,

      promoList: [
        {
          img: '/new/img/events/whats-new/teh-ais.webp',
          alt: 'Epic FIFA Teh Ais Moment',
          end: '2026-07-19',
          link: "june-highlights",
          option: 0
        },
        {
          img: '/new/img/events/whats-new/rezeki.webp',
          alt: 'Rezeki Video Challenge',
          end: '2026-12-31',
          link: "rezeki",
          option: 1
        },
        {
          img: '/new/img/events/whats-new/champions-legue.webp',
          alt: 'EpicWin Champions League',
          end: '2026-07-19',
          link: "june-highlights",
          option: 0
        }
      ]
    }
  },

  computed: {
    displayList() {
      // clone once for seamless loop
      return [...this.promoList, ...this.promoList]
    }
  },

  mounted() {
    this.createKeyframeStyle()

    this.$nextTick(() => {
      requestAnimationFrame(this.initMarquee)
    })

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    clearTimeout(this.resizeTimer)

    if (this.styleEl && this.styleEl.parentNode) {
      this.styleEl.parentNode.removeChild(this.styleEl)
    }
  },

  methods: {
    formatEndDate(date, option) {
      const end = new Date(date)
      const today = new Date()

      today.setHours(0, 0, 0, 0)

      if (end < today) {
        return 'ENDED'
      }

      if(option == 0)
        return `ENDS ON ${end.getDate()} ${this.months[end.getMonth()]} ${end.getFullYear()}`
      if(option == 1)
        return `ENDS ON ${this.months[end.getMonth()]} ${end.getFullYear()}`
    },

    createKeyframeStyle() {
      this.styleEl = document.createElement('style')
      this.styleEl.type = 'text/css'
      document.head.appendChild(this.styleEl)
    },

    initMarquee() {
      const track = this.$refs.track

      if (!track || !this.styleEl) return

      const all = Array.from(track.children)
      const half = all.length / 2

      const setW = all
        .slice(0, half)
        .reduce((total, card) => {
          return total + card.offsetWidth + this.gap
        }, 0)

      this.styleEl.textContent = `
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }

          100% {
            transform: translateX(-${setW}px);
          }
        }
      `

      track.style.animation = 'none'

      requestAnimationFrame(() => {
        track.style.animation = `marquee ${this.speed}s linear infinite`
      })
    },

    handleResize() {
      clearTimeout(this.resizeTimer)

      this.resizeTimer = setTimeout(() => {
        this.initMarquee()
      }, 120)
    },

    pauseMarquee() {
      const track = this.$refs.track
      if (track) {
        track.style.animationPlayState = 'paused'
      }
    },

    resumeMarquee() {
      const track = this.$refs.track
      if (track) {
        track.style.animationPlayState = 'running'
      }
    },

    openPage(link){
      if(link){
        this.$router.push(`/${link}`).catch(err => {});
      }
    }
  }
}
</script>
<style lang="css" scoped>
.widget {
  width: 100%;
  /* max-width: 1000px; */
}

/* ── Header ── */
.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.widget-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.title-icon {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #9333ea, #6d28d9);
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 14px;
  flex-shrink: 0;
}

.events-pill {
  background: linear-gradient(135deg, #7c3aed, #9333ea);
  color: #fff;
  border: none;
  padding: 9px 20px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.5px;
  white-space: nowrap;
  transition: opacity 0.2s;
}
.events-pill:hover { opacity: 0.85; }

/* ── Marquee ── */
.carousel-viewport {
  overflow: hidden;
  border-radius: 18px;
}

.carousel-track {
  display: flex;
  gap: 16px;
}

.carousel-track:hover {
  animation-play-state: paused;
}

/* ── Cards ── */
.card {
  flex: 0 0 calc((100% - 32px) / 3);
  border-radius: 16px;
  overflow: hidden;
  background: #18163b;
  border: 1px solid rgba(109, 40, 217, 0.2);
  cursor: pointer;
  transition: border-color 0.25s, box-shadow 0.25s;
}

.card:hover {
  border-color: rgba(147, 51, 234, 0.55);
  box-shadow: 0 12px 32px rgba(109, 40, 217, 0.25);
}

.card-thumb {
  width: 100%;
  aspect-ratio: 16 / 7.5;
  overflow: hidden;
}

.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
  transition: transform 0.4s;
}
.card:hover .card-thumb img { transform: scale(1.04); }

.card-body {
  padding: 10px 14px 12px;
}

.card-timer {
  display: flex;
  align-items: center;
  gap: 6px;
}

.timer-label {
  color: #fbbf24;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.display-title{
  color: #8470ff;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
}

/* ── Mobile ── */
@media (max-width: 700px) {
  .card { flex: 0 0 75%; }
  .widget-title { font-size: 12px; letter-spacing: 1.2px; }
  .widget-title, .display-title { font-size: 15px; letter-spacing: 1.2px; }
  
}


</style>